import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=b0e335e8&scoped=true"
import script from "./invitations.vue?vue&type=script&lang=js"
export * from "./invitations.vue?vue&type=script&lang=js"
import style0 from "./invitations.vue?vue&type=style&index=0&id=b0e335e8&prod&scoped=true&lang=css"
import style1 from "./invitations.vue?vue&type=style&index=1&id=b0e335e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e335e8",
  null
  
)

export default component.exports